export default __webpack_public_path__ + "static/extract-balthazaurus-scroll-dd9611878009a3fb9d259f105061c00d.mp4";